import { Component, Vue, Watch, Prop} from "vue-property-decorator";

@Component
export default class PaymentWidget extends Vue {
    @Prop()
    protected paymentWidget!: string;

    constructor() {
        super();
    }

    protected mounted() {
        if (this.paymentWidget) {
            $("#klarna-widget").append(this.paymentWidget);
        }
    }


    // FINJA-928 (commented temporarily, enable later)
    protected created() {
        // this.scrollMapTextIntoView();
    }

    // protected scrollMapTextIntoView() {
    //     const mapElem = document.getElementById("delivery-info");
    //     if (mapElem) {
    //         mapElem.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    //     }
    // }
}
